import { Link } from "gatsby";
import React from "react";
import styled from "styled-components";
import { breakpoints } from "../styles/Variables";

const NavStyles = styled.nav`
  position: relative;
  z-index: 10;
  mix-blend-mode: difference;

  .logo {
    position: fixed;
    display: inline-block;
    font-family: "Adam";
    transform: rotate(90deg);
    transform-origin: left;
    transition: all 0.5s;
    left: 8vw;
    top: calc(50% - 35vh);
    font-size: 7.75vh;

    @media (max-width: ${breakpoints.breakHome}) {
      top: 4rem;
      left: 50%;
      transform: translateX(-50%);
      font-size: 5vh;
    }

    a {
      border: none;
      text-decoration: none;
      color: white;
      transition: letter-spacing 0.75s;

      &:hover {
        border: none;
        letter-spacing: 5px;
      }
    }
  }

  &[data-path="work"] {
    mix-blend-mode: unset;

    .logo {
      transform: unset;
      width: 0.6em;
      overflow: hidden;
      top: 1rem;
      left: 1rem;
    }
  }
`;

const Nav = (props) => {
  const { className } = props;

  return (
    <NavStyles className={className} data-path={props["data-path"]}>
      <div className="logo">
        <Link to="/">Balthazaurus</Link>
      </div>
    </NavStyles>
  );
};

export default Nav;
